import React from 'react';

const LighthouseModal = ({
    isOpen,
    onClose,
    isReportLoading,
    lighthouseReportHtml,
    lighthouseReportError
}) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(7, 7, 10, 0.92)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10000,
                padding: '24px'
            }}
            onClick={onClose}
        >
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: '1440px',
                    height: '100%',
                    maxHeight: '920px',
                    backgroundColor: '#121212',
                    borderRadius: '10px',
                    boxShadow: '0 18px 60px rgba(0, 0, 0, 0.55)',
                    border: '1px solid rgba(100, 181, 246, 0.35)',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '14px',
                        right: '14px',
                        backgroundColor: 'rgba(220, 53, 69, 0.92)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: '42px',
                        height: '42px',
                        fontSize: '24px',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontWeight: 'bold',
                        boxShadow: '0 8px 20px rgba(220, 53, 69, 0.45)',
                        transition: 'transform 0.2s ease, background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = 'rgba(207, 46, 60, 0.95)';
                        e.target.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'rgba(220, 53, 69, 0.92)';
                        e.target.style.transform = 'scale(1)';
                    }}
                >
                    ×
                </button>
                <div
                    style={{
                        flex: 1,
                        overflow: 'auto',
                        backgroundColor: '#0c0c0c',
                        padding: '16px'
                    }}
                >
                    {isReportLoading && (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#e0e0e0',
                                gap: '8px',
                                height: '100%'
                            }}
                        >
                            <span style={{ fontSize: '14px', fontWeight: 600 }}>
                                Loading Lighthouse report…
                            </span>
                        </div>
                    )}

                    {!isReportLoading && lighthouseReportError && (
                        <div
                            style={{
                                color: '#ff6b6b',
                                fontSize: '14px',
                                backgroundColor: 'rgba(255, 107, 107, 0.08)',
                                border: '1px solid rgba(255, 107, 107, 0.4)',
                                borderRadius: '8px',
                                padding: '16px',
                                maxWidth: '480px',
                                margin: '40px auto'
                            }}
                        >
                            {lighthouseReportError}
                        </div>
                    )}

                    {!isReportLoading && !lighthouseReportError && lighthouseReportHtml && (
                        <iframe
                            title="Lighthouse report"
                            srcDoc={lighthouseReportHtml}
                            sandbox="allow-scripts allow-same-origin allow-popups"
                            style={{
                                width: '100%',
                                height: '100%',
                                border: 'none',
                                borderRadius: '8px',
                                backgroundColor: '#fff'
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default LighthouseModal;








